export default __webpack_public_path__ + "static/media/instagram.9f6737cf.png";